function About() {
  return (
    <>
      <div className="container">
        <h1 className="text-center p-2">About</h1>
        <p className="text-center p-2">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt quam
          totam vel repudiandae incidunt minima harum laboriosam itaque eveniet
          tempore.
        </p>

      </div>
    </>
  );
}

export { About };
